import { cn } from "@babybjorn/ui";
import * as s from "./ErrorMessage.module.scss";

type Props = {
	message: string | undefined;
} & React.HTMLAttributes<HTMLParagraphElement>;

const ErrorMessage = ({ message, className }: Props) => {
	return <p className={cn(s.errorMessage, className)}>{message}</p>;
};

export default ErrorMessage;
